export const sanitizeFileName = (fileName: string): string => {
  if (!fileName) return '';
  
  const lastDotIndex = fileName.lastIndexOf('.');
  const hasExtension = lastDotIndex > 0 && lastDotIndex < fileName.length - 1;
  
  let name = hasExtension ? fileName.substring(0, lastDotIndex) : fileName;
  const extension = hasExtension ? fileName.substring(lastDotIndex) : '';
  
  // Solo mantener letras, números, espacios y guiones
  name = name
    .replace(/[^a-zA-Z0-9\s-]/g, '-')
    .replace(/[-\s]+/g, '-')
    .replace(/^-+|-+$/g, '');
  
  return name + extension;
};